import React, {ReactNode} from "react";
import i18next from "i18next";
import PortalContext from "../../portal/PortalContext";
import {MessageLogDefinition} from "../../shared/log/MessageLog";
import Message from "../../shared/log/Message";
import Translate from "../../shared/translation/Translate";
import Icon from "../../shared/components/Icon";
import FunctionHelper from "../../shared/helper/FunctionHelper";
import {MessageLogProperties, MessageLogStatus} from "../../shared/log/MessageLogInterface";

interface PortalMessageLogProperties extends MessageLogProperties {
	context: PortalContext;
}

interface PortalMessageLogStatus extends MessageLogStatus {
}

export class PortalMessageLogDefinition extends MessageLogDefinition<PortalMessageLogProperties,
	PortalMessageLogStatus> {
	protected renderList(): ReactNode {
		let messages: Array<Message> = [];
		for (let message of this.props.messages.get()) {
			messages.push(Message.fromJson(message));
		}

		messages = messages.sort((a, b) => {
			let aDate: Date = new Date(a.date);
			let bDate: Date = new Date(b.date);
			return aDate < bDate ? 1 : 0;
		});

		let entries: Array<ReactNode> = [];
		for (let message of messages) {
			let date: Date = new Date(message.date);

			entries.push(
				<tr key={message.id} className={message.type}>
					<td>{date.toLocaleString(i18next.language)}</td>
					<td><Icon icon={"icon-" + message.type}/></td>
					<td><Translate {...this.props} data={message.message} namespace={"message"}
								   values={message.context}/></td>
					<td>{FunctionHelper.applyValue(message.context?.filename, "")}</td>
					<td>{message.code}</td>
				</tr>
			);
		}

		if (entries.length === 0) {
			return (
				<p className="no-results">
					<Translate {...this.props} data="log.empty"/>
				</p>
			);
		} else {
			return (
				<>
					<table className="log-header">
						<thead>
						<tr>
							<th>
								<Translate {...this.props} data="log.date"/>
							</th>
							<th/>
							<th>
								<Translate {...this.props} data="log.message"/>
							</th>
							<th>
								<Translate {...this.props} data="log.name"/>
							</th>
							<th>
								<Translate {...this.props} data="log.code"/>
							</th>
						</tr>
						</thead>
					</table>
					<div className="log-content">
						<table>
							<tbody>{entries}</tbody>
						</table>
					</div>
				</>
			)
		}
	}
}

const PortalMessageLog = React.memo(PortalMessageLogDefinition,
	(prevProps: Readonly<MessageLogProperties>, nextProps: Readonly<MessageLogProperties>) => {
		if (nextProps.showLog !== prevProps.showLog) {
			return false;
		}

		if (nextProps.language !== prevProps.language) {
			return false;
		}

		if (!nextProps.messages.equals(prevProps.messages)) {
			return false;
		}

		return true;
	}
);

export default PortalMessageLog;